export default "__VITE_ASSET__xZzC3sS8__"